//import liraries
import { Dimensions } from "react-native";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";

const isSmallDevice = Dimensions.get("window").width < 767;
const isTabView =
  Dimensions.get("window").width > 767 && Dimensions.get("window").width < 1024;

// define your styles
const useStyles = CreateResponsiveStyle(
  {
    rechargeViewStyleDisable: {
      width: 53,
      height: 15,
      borderRadius: 27,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "gray",
      alignItems: "center",
      justifyContent: "center",
      marginLeft: 15,
      marginTop: 3,
    },
    rechargeTextStyleDisable: {
      fontFamily: "Inter",
      fontSize: 7,
      fontWeight: "600",
      fontStyle: "normal",
      lineHeight: 9,
      letterSpacing: 0.14,
      textAlign: "center",
      color: "gray",
    },
    mainContainer: {
      height: 375,
      marginTop: 30,
      marginBottom: 30,
    },
    addVehText:{
      fontFamily: "Inter",
      fontSize: 19,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 23,
      letterSpacing: 0.38,
      textAlign: "center",
      color: "#bd2d37",
      paddingLeft: 15,
    },
    addTagText:{
      fontFamily: "Inter",
      fontSize: 26,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 36,
      letterSpacing: 0,
      textAlign: "left",
      color: "#66625f",
      paddingTop: 15,
      paddingLeft: 10,
    },
    addVehLink:{
      height: 48,
      width: 219,
      paddingHorizontal: 10,
      borderRadius: 27,
      borderStyle: "solid",
      borderWidth: 2,
      borderColor: "#bd2d37",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      marginTop: 30,
    },
    container: {
      width: 1050,
      height: 355,
      marginTop: 30,
      marginLeft: 30,
      backgroundColor: "#ffffff",
      borderRadius: 15,
      marginBottom: 30,
      
    },
    viewStyle: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      marginHorizontal: 10,
      marginVertical: 5,
      width: 300,
      height: 80,
    },
    vehicleNoStyle: {
      fontFamily: "Inter",
      fontSize: 11,
      fontWeight: "600",
      fontStyle: "normal",
      lineHeight: 13,
      letterSpacing: 0,
      textAlign: "left",
      color: "#02122c",
      paddingBottom: 3,
    },
    tagBalanceStyle: {
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0,
      textAlign: "left",
      color: "#02122c",
      paddingLeft: 20,
    },
    secondRowStyle: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-end",
    },
    lowBalanceOval: {
      width: 6,
      height: 6,
      borderRadius: 3,
      backgroundColor: "#FF0000",
      marginRight: 10,
    },
    lowBalanceOval1: {
      width: 10,
      height: 10,
      borderRadius: 5,
      backgroundColor: "rgba(255,0,0,0.1)",
      position: "absolute",
      top: -2,
      left: -2,
    },
    lowBalanceOval2: {
      width: 14,
      height: 14,
      borderRadius: 7,
      backgroundColor: "rgba(255,0,0,0.1)",
      position: "absolute",
      top: -4,
      left: -4,
    },
    lowBalanceText: {
      fontSize: 11,
      color: "#FF0000",
      fontWeight: "bold",
      marginLeft: 3,
    },
    searchTextStyle: {
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 17,
      letterSpacing: 0.99,
      textAlign: "left",
      color: "#ffffff",
    },
    searchTextInputStyle: {
      width: 177.1,
      height: 26.8,
      backgroundColor: "#ffffff",
      marginLeft: 10,
      fontFamily: "Inter",
      fontSize: 11,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0.84,
      textAlign: "left",
      color: "#66625f",
      paddingHorizontal: 10,
      borderRadius: 5,
    },
    searchIconContainerStyle: {
      position: "absolute",
      zIndex: 999,
      right: 20,
    },
    searchIconStyle: {
      width: 13,
      height: 12.5,
      resizeMode: "contain",
    },
    flatListStyle: {
      height: 200,
      paddingBottom: 20,
      marginTop: 20,
    },
    verticalLineStyle: {
      width: 222.4,
      height: 0,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#d7dbde",
      marginTop: 20,
    },
    rechargeViewStyle: {
      width: 53,
      height: 15,
      borderRadius: 27,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#bd2d37",
      alignItems: "center",
      justifyContent: "center",
      marginLeft: 15,
      marginTop: 3,
    },
    rechargeTextStyle: {
      fontFamily: "Inter",
      fontSize: 7,
      fontWeight: "600",
      fontStyle: "normal",
      lineHeight: 9,
      letterSpacing: 0.14,
      textAlign: "center",
      color: "#bd2d37",
    },
    myVehTextStyle: {
      fontFamily: "Inter",
      fontSize: 16,
      fontWeight: "600",
      fontStyle: "normal",
      lineHeight: 19,
      letterSpacing: 0,
      textAlign: "left",
      color: "#5f5f5f",
      paddingLeft: 60,
      paddingTop: 15,
    },
    scrollViewStyle: {
      marginBottom: -30,
      marginLeft: 30,
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      mainContainer: {
        width: 800,
        borderRadius: 15,
      },
      container: {
        width: "97%",
      },
    },
    [DEVICE_SIZES.MD]: {
      mainContainer: {
        height: 749,
        width: "95%",
        borderRadius: 15,
      },
      container: {
        width: "97%",
        height: "90%",
      },
      flatListStyle: {
        height: 500,
      },
      viewStyle: {
        width: 300,
        marginHorizontal: 25,
      },
      verticalLineStyle: {
        width: 135,
      },
      myVehTextStyle: {
        paddingLeft: 30,
      },
      scrollViewStyle: {
        marginLeft: 10,
      },
    },
    [DEVICE_SIZES.SM]: {
      mainContainer: {
        width: 528,
        height: 649,
        borderRadius: 15,
      },
      container: {
        width: "97%",
        height: "90%",
      },
      flatListStyle: {
        height: 500,
      },
      viewStyle: {
        width: 300,
        marginHorizontal: 25,
      },
      verticalLineStyle: {
        width: 135,
      },
      myVehTextStyle: {
        paddingLeft: 30,
      },
    },
    [DEVICE_SIZES.XS]: {
      mainContainer: {
        width: 322.9,
        height: 800,
        borderRadius: 15,
        alignSelf: "center",
      },
      container: {
        width: "100%",
        height: 700,
        marginLeft: 0,
      },
      flatListStyle: {
        height: "50%",
      },
      viewStyle: {
        width: 250,
        marginHorizontal: 5,
      },
      verticalLineStyle: {
        width: 135,
      },
      searchTextStyle: {
        fontSize: 9,
        lineHeight: 13,
      },
      searchTextInputStyle: {
        width: 132.3,
        height: 17.1,
        fontSize: 8,
        lineHeight: 11,
      },
      searchIconStyle: {
        width: 10.6,
        height: 10.3,
      },
    },
  }
);

//make this component available to the app
export default useStyles;
